const PREFERENCES_STORAGE_KEY = "raytio-language-preferences";

/**
 * Gets the user's country code from various sources.
 * Priority: localStorage > navigator.language > navigator.languages > undefined
 *
 * Mirrors the client's getUserCountryCode() from helpers/schema/countryFiltering.ts
 * but without window.country (CloudFront header) since the marketplace
 * does not fetch the white-labeling API.
 */
export const getUserCountryCode = (): string | undefined => {
  try {
    const stored = localStorage.getItem(PREFERENCES_STORAGE_KEY);
    if (stored) {
      const prefs = JSON.parse(stored);
      if (prefs.country) {
        return String(prefs.country).toUpperCase();
      }
    }
  } catch {
    // Ignore localStorage / parse errors
  }

  const { language } = navigator;
  if (language && language.includes("-")) {
    const countryCode = language.split("-")[1];
    return countryCode?.toUpperCase();
  }

  if (navigator.languages && navigator.languages.length > 0) {
    const firstLanguage = navigator.languages[0];
    if (firstLanguage && firstLanguage.includes("-")) {
      const countryCode = firstLanguage.split("-")[1];
      return countryCode?.toUpperCase();
    }
  }

  return undefined;
};
